import "@/styles/base.scss";
import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { router } from "@/app/router";
import { initTelegram } from "@/app/telegram";
import { ErrorBoundary } from "@/ui/ErrorBoundary/ErrorBoundary";
import i18n from "@/i18n";

initTelegram();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);

root.render(
  <ErrorBoundary>
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  </ErrorBoundary>
);
